import { filterObject } from '../utils/sharedFunctions';

import { fieldKeys, getAddressHash } from './addressUtils';

export const initialState = {};


export const SAVE_ADDRESS_FIELDS = '@@mallfront/SAVE_ADDRESS_FIELDS';
export const REMOVE_ADDRESS = '@@mallfront/REMOVE_ADDRESS';
export const CLEAR_ADDRESSES = '@@mallfront/CLEAR_ADDRESSES';


export function addressReducer(state = initialState, action) {
    switch (action.type) {
        case SAVE_ADDRESS_FIELDS: {
            const address = filterObject(action.fieldValues, (_, key) => fieldKeys.includes(key));
            const hashKey = getAddressHash(address);
            return { ...state, [hashKey]: { ...address, hashKey } };
        }
        case REMOVE_ADDRESS: {
            const { [action.addressHash]: value, ...remainder } = state;
            return remainder;
        }
        case CLEAR_ADDRESSES: {
            return {};
        }
        default:
            return state;
    }
}


export function saveAddressFields(fieldValues) {
    return {
        type: SAVE_ADDRESS_FIELDS,
        fieldValues
    };
}

export function removeAddressWithHash(addressHash) {
    return {
        type: REMOVE_ADDRESS,
        addressHash
    };
}

export const clearAddresses = () => ({
    type: CLEAR_ADDRESSES
});
